{
  "el": {
    "todo_list": {
      "actions": {
        "add": "Δημιουργία λίστας εργασιών",
        "cancel": "Αναίρεση",
        "delete_todo_list": "Διαγραφή λίστας",
        "edit": "Επεξεργασία λίστας εργασιών",
        "new": "Λίστα εργασιών",
        "save": "Αποθήκευση",
        "title": "Τίτλος λίστας"
      },
      "attributes": {
        "name": "Τίτλος"
      },
      "labels": {
        "assignToLevel": "Ανάθεση σε επίπεδο",
        "createdAt": "Δημιουργήθηκε στις",
        "filter_employee": "Υπεύθυνος",
        "newTodoList": "Νέα λίστα εργασιών",
        "sort": {
          "created_at_asc": "Παλαιότερα πρώτα",
          "created_at_desc": "Νεότερα πρώτα",
          "name_lower_asc": "Όνομα Α → Ω",
          "name_lower_desc": "Όνομα Ω → Α"
        }
      },
      "placeholders": {
        "employees": {
          "new": {
            "subtitle": "Έχε επισκόπηση όσων έχετε να κάνετε εσύ και η ομάδα σου.",
            "title": "Άνοιξε μια νέα λίστα εργασιών"
          }
        }
      },
      "toasts": {
        "create": "Η λίστα εργασιών δημιουργήθηκε με επιτυχία",
        "delete": "Η λίστα εργασιών διαγράφηκε με επιτυχία",
        "update": "Η λίστα εργασιών ενημερώθηκε με επιτυχία"
      },
      "validation": {
        "needTitle": "Ο τίτλος είναι υποχρεωτικός"
      }
    }
  }
}
